export const glpMedications = [
    'semaglutide',
    'ozempic',
    'wegovy',
    'dulaglutide',
    'trulicity',
    'liraglutide',
    'victoza',
    'saxenda',
    'exenatide',
    'byetta',
    'bydureon',
    'lixisenatide',
    'adlyxin',
    'tirzepatide',
    'mounjaro',
    'zepbound'
];
